import React from "react";
import { Reveal, Label, SectionTitle } from "@/components/Reveal";
import { Check, Crown } from "lucide-react";
import { LeadForm } from "@/components/LeadForm";
import { BRIDAL_LOOKS, BRIDAL_PACKAGES, IMAGES } from "@/data/content";

export default function Bridal() {
  return (
    <>
      <section className="relative pt-40 pb-20 overflow-hidden">
        <div className="absolute inset-0"><img src={IMAGES.bridal1} alt="" className="w-full h-full object-cover opacity-40" /><div className="absolute inset-0 bg-gradient-to-r from-midnight via-midnight/70 to-midnight/30" /><div className="absolute inset-0 bg-gradient-to-t from-midnight to-transparent" /></div>
        <div className="relative max-w-5xl mx-auto px-5 lg:px-8">
          <Label>Bridal Studio</Label>
          <h1 className="text-5xl sm:text-6xl lg:text-7xl tracking-tighter mt-5 max-w-3xl">Your Big Day, <span className="gold-shimmer italic">Flawlessly Yours.</span></h1>
          <p className="text-lg text-white/75 mt-6 max-w-2xl">HD, airbrush and signature bridal artistry designed to make you the most radiant version of yourself.</p>
        </div>
      </section>

      <section className="py-16 max-w-7xl mx-auto px-5 lg:px-8">
        <SectionTitle label="Makeup Artistry" title="Every Look, Perfected" />
        <div className="flex flex-wrap justify-center gap-3">
          {BRIDAL_LOOKS.map((l) => (
            <span key={l} className="glass rounded-full px-5 py-2.5 text-sm text-white/85 transition-colors duration-500" data-testid={`look-${l.toLowerCase().replace(/ /g,'-')}`}>{l}</span>
          ))}
        </div>
      </section>

      <section className="py-16 grid md:grid-cols-4 gap-4 max-w-7xl mx-auto px-5 lg:px-8">
        {[IMAGES.bridal1, IMAGES.bridal2, IMAGES.bridal3, IMAGES.bridal4].map((img, i) => (
          <Reveal key={i} delay={i * 0.08}><div className="aspect-[3/4] rounded-lg overflow-hidden border border-gold/20"><img src={img} alt="Bridal portfolio" className="w-full h-full object-cover hover:scale-110 transition-transform duration-700" /></div></Reveal>
        ))}
      </section>

      <section className="py-20 bg-royal/20 border-y border-gold/10">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <SectionTitle label="Bridal Packages" title="Choose Your Signature" sub="From essential elegance to the ultimate royal experience — every package is fully customisable." />
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {BRIDAL_PACKAGES.map((p, i) => (
              <Reveal key={p.name} delay={i * 0.08}>
                <div className={`relative rounded-lg p-8 h-full flex flex-col transition-colors duration-500 ${p.royal ? "border-2 border-gold shadow-[0_0_40px_rgba(212,175,55,0.25)] bg-royal/40" : p.featured ? "glass border-gold/50" : "glass"}`} data-testid={`package-${p.name.toLowerCase().replace(/ /g,'-')}`}>
                  {(p.royal || p.featured) && <span className="absolute -top-3 left-8 bg-gold text-midnight text-[10px] font-label px-3 py-1 rounded-full">{p.tag}</span>}
                  {p.royal && <Crown className="text-gold mb-3" size={26} />}
                  <h3 className="text-2xl">{p.name}</h3>
                  {!p.royal && <p className="text-white/50 text-xs font-label mt-1">{p.tag}</p>}
                  <ul className="space-y-2.5 mt-6 flex-1">
                    {p.points.map((pt) => <li key={pt} className="flex items-start gap-2 text-white/80 text-sm"><Check size={15} className="text-gold shrink-0 mt-0.5" />{pt}</li>)}
                  </ul>
                  <a href="#bridal-form" className="btn-gold text-center mt-7 text-sm" data-testid={`enquire-${p.name.toLowerCase().replace(/ /g,'-')}`}>Enquire</a>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section id="bridal-form" className="py-24 max-w-3xl mx-auto px-5 lg:px-8">
        <SectionTitle label="Book a Consultation" title="Let's Design Your Look" />
        <LeadForm type="bridal" testid="bridal-form" cta="Request Bridal Consultation"
          extraFields={[
            { name: "package", placeholder: "Select Package", type: "select", required: true, options: BRIDAL_PACKAGES.map((p) => p.name) },
            { name: "event_date", placeholder: "Event Date", type: "date" },
          ]} />
      </section>
    </>
  );
}
